import { defineStore } from 'pinia'
import DeviceExtractionState, { DeviceExtractionStateType } from './state'
import { DeviceExtractionActions, DeviceExtractionActionsType } from './actions'
import { DeviceExtractionGetters } from './getters'

export const useDeviceExtractionStore = defineStore<
  'deviceExtraction',
  DeviceExtractionStateType,
  typeof DeviceExtractionGetters,
  DeviceExtractionActionsType
>('deviceExtraction', {
  state: DeviceExtractionState,
  actions: DeviceExtractionActions,
  getters: DeviceExtractionGetters,
})
